import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { GuiaService } from '../guias.service';
import { HeaderStateService } from '../../app-layer/header/header-state.service';
import { Subject, takeUntil } from 'rxjs';
import { DadosGuia } from '../guias.types';
import {
    expandAnimation,
    ExpandAnimationState,
    fadeAnimation,
    FadeAnimationState,
    FadeTimings,
    positionAnimation,
    PositionAnimationState,
} from '../../../../core/consts/animations';

@Component({
    selector: 'app-guia-indicador',
    standalone: true,
    imports: [],
    template: `
        <h5 class="indicador__titulo" [@expand]="estadoExpansao" [@fade]="estadoFade" [@position]="estadoPosicao">
            {{ titulo }}
        </h5>
    `,
    styleUrl: './guia-indicador.component.scss',
    animations: [
        expandAnimation(),
        fadeAnimation(FadeTimings.Linear, FadeTimings.Linear),
        positionAnimation('top', 144),
    ],
    encapsulation: ViewEncapsulation.None,
})
export class GuiaIndicadorComponent implements OnInit, OnDestroy {
    private readonly guiaService = inject(GuiaService);
    private readonly headerStateService = inject(HeaderStateService);

    private readonly onDestroy$ = new Subject<void>();

    public titulo: string | null = null;

    public idGuia: string | null = null;

    public estadoExpansao: ExpandAnimationState = ExpandAnimationState.Collapsed;

    public estadoFade: FadeAnimationState = FadeAnimationState.Out;

    public estadoPosicao: PositionAnimationState = PositionAnimationState.Default;

    public ngOnInit(): void {
        this.monitorarEstadoHeader();
        this.monitorarDadosGuia();
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private monitorarDadosGuia(): void {
        this.guiaService.getDadosGuia('INDICADOR').pipe(takeUntil(this.onDestroy$)).subscribe(this.aoAlterarDadosGuia);
    }

    private monitorarEstadoHeader(): void {
        this.headerStateService.isHeaderAbsoluteDisplayed$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(this.aoAlterarEstadoHeader);
    }

    private aoAlterarDadosGuia = (dadosGuia: DadosGuia['INDICADOR'] | null): void => {
        if (dadosGuia) {
            this.existeDadosGuia(dadosGuia);
        } else {
            this.naoExisteDadosGuia();
        }
    };

    private existeDadosGuia = (dadosGuia: DadosGuia['INDICADOR']): void => {
        const novoIdGuia = dadosGuia.id;
        const idPrevio = this.idGuia;
        if (idPrevio !== novoIdGuia) {
            this.verificaIdPrevioPreAlteracao(idPrevio);
            this.idGuia = novoIdGuia;
            this.titulo = dadosGuia.titulo;
            this.verificaIdPrevioPosAlteracao(idPrevio);
            this.validaElementoOculto();
        }
    };

    private verificaIdPrevioPreAlteracao = (idPrevio: string | null): void => {
        if (idPrevio) {
            this.estadoFade = FadeAnimationState.Out;
        } else {
            this.estadoExpansao = ExpandAnimationState.Collapsed;
        }
    };

    private verificaIdPrevioPosAlteracao = (idPrevio: string | null): void => {
        if (idPrevio) {
            this.estadoFade = FadeAnimationState.In;
        } else {
            this.estadoExpansao = ExpandAnimationState.Expanded;
        }
    };

    private validaElementoOculto = (): void => {
        if (this.estadoExpansao === ExpandAnimationState.Collapsed) {
            this.estadoExpansao = ExpandAnimationState.Expanded;
        }
        if (this.estadoFade === FadeAnimationState.Out) {
            this.estadoFade = FadeAnimationState.In;
        }
    };

    private naoExisteDadosGuia = (): void => {
        this.estadoExpansao = ExpandAnimationState.Collapsed;
        this.estadoFade = FadeAnimationState.Out;
        this.idGuia = null;
    };

    private aoAlterarEstadoHeader = (isHeaderAbsolute: boolean): void => {
        this.estadoPosicao = isHeaderAbsolute ? PositionAnimationState.Moved : PositionAnimationState.Default;
    };
}
